var map = {
  "./shape-circle-aquamarine-gradient.png": "273427",
  "./shape-circle-aquamarine-light.png": "913602",
  "./shape-circle-aquamarine.png": "529543",
  "./shape-circle-blue-gradient.png": "288156",
  "./shape-circle-blue-light.png": "938162",
  "./shape-circle-blue.png": "269797",
  "./shape-circle-cyan-gradient.png": "175899",
  "./shape-circle-cyan-light.png": "405645",
  "./shape-circle-cyan.png": "13185",
  "./shape-circle-green-gradient.png": "605212",
  "./shape-circle-green-light.png": "673600",
  "./shape-circle-green.png": "350487",
  "./shape-circle-grey100.png": "786289",
  "./shape-circle-grey1000.png": "378075",
  "./shape-circle-grey200.png": "542511",
  "./shape-circle-grey25.png": "205275",
  "./shape-circle-grey300.png": "173556",
  "./shape-circle-grey400.png": "971681",
  "./shape-circle-grey50.png": "126961",
  "./shape-circle-grey500.png": "25278",
  "./shape-circle-grey600.png": "612560",
  "./shape-circle-grey700.png": "432057",
  "./shape-circle-grey800.png": "779545",
  "./shape-circle-grey900.png": "939074",
  "./shape-circle-indigo-gradient.png": "541135",
  "./shape-circle-indigo-light.png": "638213",
  "./shape-circle-indigo.png": "189695",
  "./shape-circle-lime-gradient.png": "948342",
  "./shape-circle-lime-light.png": "253586",
  "./shape-circle-lime.png": "480738",
  "./shape-circle-magenta-gradient.png": "707171",
  "./shape-circle-magenta-light.png": "705382",
  "./shape-circle-magenta.png": "70744",
  "./shape-circle-navy-gradient.png": "815248",
  "./shape-circle-navy-light.png": "965897",
  "./shape-circle-navy.png": "14328",
  "./shape-circle-orange-gradient.png": "993423",
  "./shape-circle-orange-light.png": "806320",
  "./shape-circle-orange.png": "887438",
  "./shape-circle-purple-gradient.png": "925681",
  "./shape-circle-purple-light.png": "327510",
  "./shape-circle-purple.png": "206484",
  "./shape-circle-red-gradient.png": "923049",
  "./shape-circle-red-light.png": "527977",
  "./shape-circle-red.png": "223403",
  "./shape-circle-yellow-gradient.png": "157179",
  "./shape-circle-yellow-light.png": "116169",
  "./shape-circle-yellow.png": "696490"
};


function webpackContext(req) {
  var id = webpackContextResolve(req);
  return __webpack_require__(id);
}
function webpackContextResolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
webpackContext.keys = function webpackContextKeys() {
  return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 423052;
